import React from 'react';
import { Artifact } from '../../../types/artifact';
import { useTheme } from '../../../contexts/ThemeContext';

interface IdeaArtifactViewerProps {
  artifact: Artifact;
}

export const IdeaArtifactViewer: React.FC<IdeaArtifactViewerProps> = ({ artifact }) => {
  const { darkMode } = useTheme();

  const getIdeaContent = () => {
    if (typeof artifact.content === 'string') return { content: artifact.content };
    return artifact.content;
  };

  const idea = getIdeaContent();

  return (
    <div className="idea-artifact-viewer">
      <div className={`border rounded-lg p-6 ${
        darkMode ? 'bg-yellow-900/20 border-yellow-700' : 'bg-yellow-50 border-yellow-200'
      }`}>
        <div className="flex items-center mb-4">
          <span className="text-2xl mr-2">💡</span>
          <h3 className={`text-lg font-medium ${darkMode ? 'text-gray-100' : 'text-gray-900'}`}>
            {artifact.name}
          </h3>
        </div>

        <div className={`prose prose-sm max-w-none mb-4 ${darkMode ? 'prose-invert' : ''}`}>
          <div className={`whitespace-pre-wrap ${darkMode ? 'text-gray-200' : 'text-gray-700'}`}>
            {idea.content}
          </div>
        </div>

        {idea.tags && idea.tags.length > 0 && (
          <div className="mt-4">
            <h4 className={`text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              Tags
            </h4>
            <div className="flex flex-wrap gap-2">
              {idea.tags.map((tag: string, index: number) => (
                <span key={index} className={`px-2 py-1 text-xs rounded-full ${
                  darkMode ? 'bg-yellow-800 text-yellow-200' : 'bg-yellow-100 text-yellow-800'
                }`}>
                  {tag}
                </span>
              ))}
            </div>
          </div>
        )}

        {idea.references && idea.references.length > 0 && (
          <div className="mt-4">
            <h4 className={`text-sm font-medium mb-2 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              References
            </h4>
            <ul className={`text-sm list-disc pl-5 space-y-1 ${darkMode ? 'text-gray-300' : 'text-gray-700'}`}>
              {idea.references.map((ref: string, index: number) => (
                <li key={index}>{ref}</li>
              ))}
            </ul>
          </div>
        )}
      </div>
    </div>
  );
};
